import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useAppUi } from '../context/AppUiContext';

export default function ThemeModeToggle({ size = 'medium', edge = false, sx = {} }) {
  const { mode, toggleMode } = useAppUi();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        color="inherit"
        onClick={toggleMode}
        size={size}
        edge={edge}
        aria-label={isDark ? 'Activate light mode' : 'Activate dark mode'}
        sx={sx}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
}
